<div class="sidebar">
  <!-- 데스크톱용 플로팅 토글 버튼 -->
  <button class="desktop-toggle-btn" (click)="sidebarService.toggle()" aria-label="메뉴 토글">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"
      class="toggle-icon">
      @if (sidebarService.isOpen()) {
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      } @else {
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      }
    </svg>
  </button>

  <div class="logo-area">
    <div class="logo-brand">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        class="logo-icon">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M9 3v18M15 3v18M3 9h18M3 15h18" />
      </svg>
      <span class="logo-text">BARO</span>
    </div>
    <button class="close-sidebar-btn" (click)="sidebarService.close()" aria-label="메뉴 닫기">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
        class="close-icon">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <nav class="nav-links">
    @if (authService.isSuperAdmin() || authService.isManager()) {
    <a routerLink="/dashboard" routerLinkActive="active" class="nav-item" (click)="onNavClick()">
      <!-- Dashboard Icon -->
      <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <rect x="3" y="3" width="7" height="9" rx="1" />
        <rect x="14" y="3" width="7" height="5" rx="1" />
        <rect x="14" y="12" width="7" height="9" rx="1" />
        <rect x="3" y="16" width="7" height="5" rx="1" />
      </svg>
      <span>대시보드</span>
    </a>
    }

    <a routerLink="/elevators" routerLinkActive="active" class="nav-item" (click)="onNavClick()">
      <!-- Elevator Icon (Up/Down Cab) -->
      <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <rect x="5" y="3" width="14" height="18" rx="2" />
        <path d="M12 7v10M9 10l3-3 3 3M9 14l3 3 3-3" />
      </svg>
      <span>엘리베이터</span>
    </a>

    <a routerLink="/elevator-map" routerLinkActive="active" class="nav-item" (click)="onNavClick()">
      <!-- Map Pin Icon -->
      <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
      </svg>
      <span>지도 현황</span>
    </a>

    <a routerLink="/complaints" routerLinkActive="active" class="nav-item" (click)="onNavClick()">
      <!-- Complaint / Message Alert Icon -->
      <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2v10z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v3m0 3h.01" />
      </svg>
      <span>민원 관리</span>
    </a>

    @if (authService.isSuperAdmin()) {
    <a routerLink="/control-panels" routerLinkActive="active" class="nav-item" (click)="onNavClick()">
      <!-- Control Panel / Circuit Chip Icon -->
      <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M9 3v2m6-2v2M9 19v2m6-2v2M3 9h2m-2 6h2m14-6h2m-2 6h2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
      </svg>
      <span>제어반 관리</span>
    </a>
    }

    <a routerLink="/board" routerLinkActive="active" class="nav-item" (click)="onNavClick()">
      <!-- Board Icon -->
      <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10l4 4v10a2 2 0 01-2 2z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M14 2v6h6M8 12h8M8 16h6" />
      </svg>
      <span>게시판</span>
    </a>

    @if (authService.isSuperAdmin()) {
    <a routerLink="/admin-console" routerLinkActive="active" class="nav-item" (click)="onNavClick()">
      <!-- Admin Gear Icon -->
      <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
      <span>매니저 관리</span>
    </a>
    }

    @if (authService.isManager()) {
    <a routerLink="/manager-console" routerLinkActive="active" class="nav-item" (click)="onNavClick()">
      <!-- Manager Users Icon -->
      <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
      <span>그룹 & 직원 관리</span>
    </a>
    }
  </nav>

  <div class="sidebar-footer">
    <div class="user-profile-card">
      <div class="user-avatar">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
          class="avatar-icon">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      </div>
      <div class="user-info">
        <span class="username">{{ authService.currentUser()?.username }}</span>
        <span class="user-role">{{ getRoleName(authService.currentUser()?.role) }}</span>
      </div>
    </div>
    <button (click)="openChangePasswordModal()" class="change-password-btn" aria-label="비밀번호 변경">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
        class="btn-icon">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
      </svg>
      <span>비밀번호 변경</span>
    </button>
    <button (click)="authService.logout()" class="logout-btn" aria-label="로그아웃">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
        class="logout-icon">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
      </svg>
      <span>로그아웃</span>
    </button>
    <p class="version">v1.0.1</p>
  </div>
</div>

<app-change-password-modal [isOpen]="isPasswordModalOpen()"
  (close)="closeChangePasswordModal()"></app-change-password-modal>
